import { put, call } from 'redux-saga/effects';
import { cancelReasonsMasterList, cancelReasonsMasterLoad, cancelReasonsMasterAdd, cancelReasonsMasterModify, cancelReasonsMasterDelete,cancelReasonsList, cancelReasonsLoad, cancelReasonsAdd, cancelReasonsModify, cancelReasonsDelete } from '../services/cancelReasons';

import * as types from '../actions'; 

export function* cancelReasonsMasterListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(cancelReasonsMasterList, payload);
      yield put({ type: types.CANCEL_REASONS_MASTER_LIST_SUCCESS, response})
            
    } catch(error) {
      yield put({ type: types.CANCEL_REASONS_MASTER_LIST_ERROR, error});
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* cancelReasonsMasterAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(cancelReasonsMasterAdd, payload);
      yield put({ type: types.CANCEL_REASONS_MASTER_ADD_SUCCESS, response})
            
    } catch(error) {
      yield put({ type: types.CANCEL_REASONS_MASTER_ADD_ERROR, error});
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* cancelReasonsMasterLoadSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(cancelReasonsMasterLoad, payload);
      yield put({ type: types.CANCEL_REASONS_MASTER_LOAD_SUCCESS, response})
            
    } catch(error) {
      yield put({ type: types.CANCEL_REASONS_MASTER_LOAD_ERROR, error});
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* cancelReasonsMasterModifySaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(cancelReasonsMasterModify, payload);
      yield put({ type: types.CANCEL_REASONS_MASTER_MODIFY_SUCCESS, response})
            
    } catch(error) {
      yield put({ type: types.CANCEL_REASONS_MASTER_MODIFY_ERROR, error});
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* cancelReasonsMasterDeleteSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(cancelReasonsMasterDelete, payload);
      yield put({ type: types.CANCEL_REASONS_MASTER_DELETE_SUCCESS, response})
            
    } catch(error) {
      yield put({ type: types.CANCEL_REASONS_MASTER_DELETE_ERROR, error});
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

export function* cancelReasonsListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(cancelReasonsList, payload);
    yield put({ type: types.CANCEL_REASONS_LIST_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.CANCEL_REASONS_LIST_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* cancelReasonsAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(cancelReasonsAdd, payload);
    yield put({ type: types.CANCEL_REASONS_ADD_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.CANCEL_REASONS_ADD_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* cancelReasonsLoadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(cancelReasonsLoad, payload);
    yield put({ type: types.CANCEL_REASONS_LOAD_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.CANCEL_REASONS_LOAD_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* cancelReasonsModifySaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(cancelReasonsModify, payload);
    yield put({ type: types.CANCEL_REASONS_MODIFY_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.CANCEL_REASONS_MODIFY_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* cancelReasonsDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(cancelReasonsDelete, payload);
    yield put({ type: types.CANCEL_REASONS_DELETE_SUCCESS, response})
          
  } catch(error) {
    yield put({ type: types.CANCEL_REASONS_DELETE_ERROR, error});
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


